
import React, { useEffect } from "react";
import HeroSection from "@/components/MoralDilemmas/HeroSection";
import InfoCards from "@/components/MoralDilemmas/InfoCards";
import SampleQuestions from "@/components/MoralDilemmas/SampleQuestions";
import QuestionForm from "@/components/MoralDilemmas/QuestionForm";
import ResponseDisplay from "@/components/MoralDilemmas/ResponseDisplay";
import HeavenlyLoader from "@/components/HeavenlyLoader";
import { useMoralDilemmas } from "@/components/MoralDilemmas/useMoralDilemmas";

const MoralDilemmasTool: React.FC = () => {
  const {
    question,
    setQuestion,
    isLoading,
    response,
    error,
    isSaving,
    handleSubmit,
    saveResponse,
    shareViaEmail,
    shareViaSMS,
    shareToFacebook,
    handleExampleClick,
    handleResetResponse
  } = useMoralDilemmas();

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 py-10">
      {isLoading && <HeavenlyLoader message="Seeking biblical wisdom for moral guidance..." />}
      
      {/* Hero Section */}
      <HeroSection />
      
      {/* Info Cards */}
      <InfoCards />
      
      {/* Sample Questions */}
      <SampleQuestions onExampleClick={handleExampleClick} />
      
      {/* Question Form */}
      <QuestionForm 
        question={question}
        setQuestion={setQuestion}
        handleSubmit={handleSubmit}
        isLoading={isLoading}
      />
      
      {/* Error Display */}
      {error && (
        <div className="bg-red-50 border border-red-300 text-red-800 p-4 rounded-md mb-6">
          <p>{error}</p>
        </div>
      )}
      
      {/* Response Display */}
      {response && !isLoading && (
        <ResponseDisplay 
          question={question}
          response={response}
          isSaving={isSaving}
          onSave={saveResponse}
          onShareEmail={shareViaEmail}
          onShareSMS={shareViaSMS}
          onShareFacebook={shareToFacebook}
          onNewQuestion={handleResetResponse}
        />
      )}
    </div>
  );
};

export default MoralDilemmasTool;
